function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React, { useState } from 'react';
import PropTypes from 'prop-types';
import identity from 'lodash.identity';
import debounce from 'lodash.debounce';
import { Autocomplete } from '../Autocomplete';
import useFormHelpers from '../../hooks/useFormHelpers';
const INITIAL_REQUEST_STATE = {
  loading: false,
  options: []
};
const LOADING_REQUEST_STATE = {
  loading: true,
  options: []
};

const AsyncAutocomplete = ({
  getSearchResults,
  ...props
}) => {
  const [{
    options,
    loading
  }, setRequestState] = useState({
    loading: false,
    options: []
  });
  const [debouncedOnInputChange] = useState(() => debounce(async searchTerm => {
    const options = await getSearchResults(searchTerm);
    setRequestState({
      loading: false,
      options
    });
  }, 300));
  return React.createElement(Autocomplete, _extends({}, props, {
    loading: loading,
    filterOptions: identity // this must be here otherwise not all options get rendered; since this is async, we filter with our getSearchResults function call
    ,
    onInputChange: (event, searchTerm) => {
      if (!searchTerm) {
        setRequestState(INITIAL_REQUEST_STATE);
      } else {
        if (!loading) {
          setRequestState(LOADING_REQUEST_STATE);
        }

        debouncedOnInputChange(searchTerm);
      }
    },
    options: options,
    forcePopupIcon: false
  }));
};

AsyncAutocomplete.propTypes = {
  getSearchResults: PropTypes.func.isRequired
};

const LinkedAsyncAutocomplete = props => {
  // value must be removed from props since AsyncAutocomplete is uncontrolled
  const {
    value,
    ...helpers
  } = useFormHelpers(props);
  return React.createElement(AsyncAutocomplete, helpers);
};

LinkedAsyncAutocomplete.propTypes = {
  name: PropTypes.string.isRequired
};
export { AsyncAutocomplete, LinkedAsyncAutocomplete };